import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import Header from "../../components/Header";
import LineChart from "../../components/LineChart";
import { tokens } from "../../theme";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

const Line = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("adminToken");
        const response = await axios.get(
          `${BASE_URL}/api/admin/dashboard-stats`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        if (!response.data?.success) {
          throw new Error(response.data?.message || "Failed to load line data");
        }

        const revenueByDay = response.data?.revenueByDay || [];
        const formatted = [
          {
            id: "Revenue (KES)",
            color: "#22c55e",
            data: revenueByDay.map((day) => ({
              x: day._id?.slice(5) || day._id,
              y: Number(day.revenue || 0),
            })),
          },
        ];
        setData(formatted);
      } catch (error) {
        console.error("Failed to fetch line chart data:", error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <Box m="20px">
      <Header title="Line Chart" subtitle="Revenue trend from real data" />
      <Box height="75vh">
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <CircularProgress />
          </Box>
        ) : data.length > 0 && data[0]?.data?.length > 0 ? (
          <LineChart data={data} />
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <Typography color={colors.grey[300]}>No revenue trend data available yet.</Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Line;
